import { injectable, inject } from 'inversify';

import { History } from '@vk-hr-tek/core/history';
import { RoleService } from '@vk-hr-tek/core/http';

import { modules } from '../../modules';
import { TargetAudienceRouter } from '../../../target-audience/types';

@injectable()
export class TargetAudienceRouterService implements TargetAudienceRouter {
  constructor(
    @inject(History) private history: History,
    @inject(RoleService) private readonly role: RoleService,
  ) {}

  goToList(query?: string) {
    if (!query || query === '?') {
      this.history.push({
        pathname: `/${this.role.get()}/${modules.target_audience.basename}`,
      });

      return;
    }

    this.history.push({
      pathname: `/${this.role.get()}/${modules.target_audience.basename}`,
      search: query.startsWith('?') ? query : `?${query}`,
    });
  }

  goToCreate(accountId: string) {
    this.history.push({
      pathname: `/${this.role.get()}/${modules.target_audience.basename}/create`,
      search: `?account_id=${accountId}`,
    });
  }

  goToUpdate(id: string, accountId: string) {
    this.history.push({
      pathname: `/${this.role.get()}/${modules.target_audience.basename}/edit/${id}`,
      search: `?account_id=${accountId}`,
    });
  }
}
